import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import UploadButton from '../../../uploadimage/components/UploadButton';
import { forwardRef } from 'react';
import styles from './CTAButtonWrapper.scss';

const CTAButtonWrapper = forwardRef((props, ref) => {
  const { text, variant, leftIcon, rightIcon, leftComponent, className, size, children, ...rest } = props;
  const CTAButtonWrapperClassName = `${[
    styles['CTAbutton-wrapper'],
    styles[variant],
    className || '',
    styles[size] || '',
  ].join(' ')}`;
  return (
    <Button ref={ref} {...rest} className={CTAButtonWrapperClassName}>
      {leftIcon && (
        <div
          className={styles['icon']}
          style={{
            '--left-dark-icon': `url('${leftIcon.dark}')`,
            '--left-light-icon': `url('${leftIcon.light}')`,
          }}
        />
      )}
      {leftComponent && (
        <>
          <div className={styles['dark-component']}>{leftComponent.dark}</div>
          <div className={styles['white-component']}>{leftComponent.light}</div>
        </>
      )}
      {text && <div className={styles['label']}>{text}</div>}
      {rightIcon && (
        <div
          className={styles['icon']}
          style={{
            '--right-dark-icon': `url('${rightIcon.dark}')`,
            '--right-light-icon': `url('${rightIcon.light}')`,
          }}
        />
      )}
      {children}
      {text && text === 'Upload New Artwork' && <UploadButton className={styles['upload-button']} />}
    </Button>
  );
});
CTAButtonWrapper.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'success']).isRequired,
  leftIcon: PropTypes.shape({
    dark: PropTypes.string,
    light: PropTypes.string,
  }),
  rightIcon: PropTypes.shape({
    dark: PropTypes.string,
    light: PropTypes.string,
  }),
  className: PropTypes.string,
  size: PropTypes.string,
};
export default CTAButtonWrapper;
